import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-listing-description',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="description-section" *ngIf="description">
      <h2 class="section-title">Təsvir və əlavə məlumat</h2>
      <div class="description-content">
        {{ description }}
      </div>
    </div>
  `,
  styles: [`
    .description-section {
      padding: 32px 0;
      border-top: 1px solid #f1f2f6;
    }
    .section-title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 16px;
      color: #2d3436;
    }
    .description-content {
      font-size: 16px;
      line-height: 1.6;
      color: #2d3436;
      white-space: pre-line;
      max-width: 3000px;
    }
  `]
})
export class ListingDescriptionComponent {
  @Input() description: string = '';
}
